import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//import ModalAgregarLineasScorecard from './ModalAgregarLineasScorecard';
import { LoaderScreen } from "../../components/LoaderScreen";
// import { FiltroPlantillasKarbot } from "./FiltroPlantillaKarbot";
// import { GetMonthName } from "../../helpers/GetMonthName";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { Checkbox } from "@mui/material";
import Button from "@mui/material/Button";
// import { ModalGuardarTelefono } from "./ModalGuardarTelefono";
import RefreshIcon from "@mui/icons-material/Refresh";

export const FacturasNoRegistradasEquipScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [data, setData] = useState([]);

  useEffect(() => {
    onActualizar();
  }, []);
  const onActualizar = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturasNoRegistradasEquip/ListadoFacturas`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  };
  const totalfacturas = data.length;

  const totalSaldoFacturas = data.reduce(
    (sum, item) => sum + Number(item.sado),
    0
  );


  return (
    <PlantillaScreen
      titulo={"DOCUMENTOS NO ENCONTRADOS EN HUMAYA DIGITAL"}
      className_main={1}
      className={"facturas-no-registradas-main-screen"}
    >
      <LoaderScreen loader={loader} />
      <div className="facturas-no-registradas-actions">
        <div
          className="facturas-no-registradas-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div
          className="facturas-no-registradas-actions-actualizar"
          onClick={() => onActualizar()}
        >
          <RefreshIcon /> Actualizar
        </div>
        {/* <FiltroPlantillasKarbot onExecute={onExecute} /> */}
      </div>
      <div className="facturas-no-registradas-numero-clientes">
        {`Se encontraron ${totalfacturas} facturas con saldo $${FormatMoney(totalSaldoFacturas)}`}
      </div>
      {/* {data === undefined || data === null || data.length === 0 ? (
                <div></div>
            ) : ( */}
      <div className="facturas-no-registradas-table scroll-4">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Sucursal</th>
              <th>
                <div>ID Cliente</div>
              </th>
              <th>
                <div>Razon Social</div>
              </th>
              <th>
                <div>Documento</div>
              </th>
              <th>
                <div>Fecha</div>
              </th>
              <th>
                <div>Vencimiento</div>
              </th>
              <th>
                <div>Importe de la Factura</div>
              </th>
              <th>
                <div>Saldo</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr>
                <td>{item.sucursal}</td>
                <td>{item.idCliente}</td>
                <td>{item.razonsocial}</td>
                <td>{item.documento}</td>
                <td>{item.fecha}</td>
                <td>{item.vencimiento}</td>
                <td>{FormatMoney(item.importeFactura, 0)}</td>
                <td>{FormatMoney(item.sado, 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* )} */}
    </PlantillaScreen>
  );
};
